import { useParams, useRouteMatch } from 'react-router-dom';
import { useGetPatientQuery } from '~/store/services/patients';
import PatientLabsTab from '~/components/maud/patients/profile/tabs/labs';

const LabsPage = () => {
  const { patientId } = useParams<{ patientId: string }>();
  const { path } = useRouteMatch();
  const reportMatch = useRouteMatch<{ diagnosticReportId: string }>({
    path: `${path}/:diagnosticReportId`,
    exact: true,
  });
  const { data: patient } = useGetPatientQuery({ patientId });

  if (!patient) return null;

  return (
    <PatientLabsTab
      diagnosticReportId={reportMatch?.params?.diagnosticReportId}
      patient={patient}
    />
  );
};

export default LabsPage;
